import React from 'react';

import Documents from '../../components/club/Documents';
import PageLayout from '../../components/layout/PageLayout';

const DocumentsPage = () => {
  return (
    <PageLayout>
      <Documents />
    </PageLayout>
  );
};

export default DocumentsPage;
